<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-menu
        v-model="menu.m1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :label="titleDate"
            prepend-icon="event"
            readonly
            v-on="on"
			:clearable="clean"
            :value="momentFormatStartDate"
            :error-messages="errorMessages"
			@click:clear="date = null"
          />
        </template>
        <v-date-picker
          header-color="primary"
          color="secondary"
          v-model="date"
          @input="menu.m1 = false"
          locale="es-419"
          :min="min"
		  :max="max"
        />
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
	import moment from "moment";
	export default {
		props: [
			"titleDate",
			"errorMessages",
			"valueDate",
			"value",
			"min",
			"clean",
			"min",
			"max"
		],
		data: () => ({
			menu: {
				m1: false
			},
			date: null,
			dateObject: null
		}),
		watch: {
			value() {
				if (this.value == "") {
					this.date = null;
					this.dateObject = null;
				} else {
					this.dateObject = this.value;
					if (this.dateObject != null && this.date == null)
						this.date = this.dateObject.toISOString().substr(0, 10);
				}
			},
			date() {
				if (this.date) {
					const [year, month, day] = this.date.split('-')
					this.dateObject = new Date(
						Number(year),
						Number(month - 1), // Note: JavaScript counts months from 0 to 11:
						Number(day),
						0,
						0,
						0
					)
				} else {
					this.dateObject = null;
				}
				this.$emit("input", this.dateObject);
			}
		},
		computed: {
			momentFormatStartDate() {
				if (this.dateObject == null) {
					if (this.date != null) {
						return moment(this.date).format("DD/MM/YYYY");
					}
				} else {
					return moment(this.dateObject).format("DD/MM/YYYY");
				}
				return "";
			}
		}
	};
</script>

<style>
</style>
